<div class="my-overlay" *ngIf="showOverlay">
  <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
</div>
<div *ngIf="signupInformations">
  <div class="row">
    <div class="col">
      <div class="row center">
        <div class="col">
          <img class="h-32" src="../../../../../assets/icons/DESKTOP/Grupo 202.png" alt="">
        </div>
      </div>
      <div class="row center">
        <div class="col">
          <span class="f-18">
            {{i18n.SIGNATURE.ASSINAR_COMO}} {{signupInformations.signer.type}}
          </span>
        </div>
      </div>
      <div class="row center">
        <div class="col pl-40px pr-40px">
          <span class="f-14">
            {{signupInformations.signer.email}}
          </span>          
        </div>
      </div>
    </div>
  </div>
  <div class="bottom-bordered"></div>
  
  <div class="row pt-24px">
    <div class="col">
      <div class="row">
        <div class="col">
          <label for="signer-name" class="default-label f-12">{{i18n.SIGNATURE.NOME_COMO_NO_CPF}}</label>
          <input id="signer-name" class="default-input" type="text" [(ngModel)]="signerData.name">
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label for="signer-cpf" class="default-label f-12">{{i18n.SIGNATURE.NUMERO_CPF}}</label>
          <input id="signer-cpf" mask="000.000.000-00" (input)="checkDocument()" class="default-input" type="text"
            [(ngModel)]="signerData.cpf">
          <br>
          <span class="f-red" *ngIf="validDocument === false">{{i18n.SIGNATURE.DOCUMENTO_INVALIDO}}</span>
        </div>
        <div class="col">
          <label for="signer-born" class="default-label f-12">{{i18n.SIGNATURE.DATA_DE_NASCIMENTO}}</label>
          <input id="signer-born" mask="00/00/0000" [dropSpecialCharacters]="false" class="default-input" type="text" [(ngModel)]="signerData.born">
        </div>
      </div>
      <div class="bottom-bordered"></div>
      <div class="row">
        <div class="col">
          <app-signature-input [signatureName]="signerData.name" (signatureImg)="testeFunc($event)">
          </app-signature-input>
        </div>
      </div>
    </div>
  </div>
  
  <div class="row center justify-content-center pt-32px">
    <div class="col">
      <button [disabled]="
      validDocument === false || 
      signerData.name === '' ||
      signerData.signature === '' ||
      signerData.born === '' ||
      blockBtn
      " class="btn btn-blue" (click)="blockScreen();saveSignature();">{{i18n.SIGNATURE.ESTOU_DE_ACORDO}}</button>
    </div>
  </div>
  <div class="row">
    <div class="col center">
      <span class="f-12 f-blue link" (click)="close()">
        {{i18n.SIGNATURE.CANCELAR}}
      </span>
    </div>
  </div>
  
  <div class="row pt-24px center pb-40px">
    <div class="col">
      <span class="f-opacited f-12">
        {{i18n.SIGNATURE.PRE_TERMOS_DE_USO}}
        <br>
        <span class="f-blue" (click)="goToUseTerms()">
          {{i18n.SIGNATURE.TERMOS_DE_USO}}.</span>
      </span>
    </div>
  </div>
</div>